<template>
  <div>
    <!-- Start Manipulation -->
    <div class="d-flex justify-content-between align-items-center mb-1">
      <div class="w-100 mr-3 searchBox-container">
        <el-form
          ref="formSearchDocument"
          label-position="left"
          @submit.native.prevent
          label-width="135px"
          :model="mData.tableRules.dataSearch.value"
          :rules="mData.tableRules.dataSearch.valid"
        >
          <el-input
            class="searchBox"
            type="text"
            v-model="mData.tableRules.dataSearch.value.text_search"
            placeholder="Tìm kiếm văn bản"
            prefix-icon="fal fa-search"
            @keyup.enter.native="fn_filterDoc"
          >
            <i
              id="closeSearchBox"
              slot="suffix"
              class="icon icon24-Filter"
              @click="fn_toggleFilter"
            ></i>
          </el-input>

          <!-- Start FILTERS -->
          <div class="main-body-search mb-3">
            <b-collapse
              :visible="mData.tableRules.showFormSearch"
              id="formSearchDocument"
            >
              <el-card v-if="mData.tableRules.showFormSearch">
                <b-row class="mt-2">
                  <b-col md="12">
                    <el-form-item label="Từ:" prop="">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.from_id"
                        clearable
                        filterable
                        placeholder="Nhập nội dung và enter để tìm kiếm"
                        no-data-text="Không có dữ liệu"
                        :filter-method="remoteSearchFrom"
                        :loading="loadingSearchFrom"
                        @keyup.enter.native="fn_enterFindFrom()"
                      >
                        <el-option
                          v-for="item in listEmployeeSearchFrom"
                          :key="item.id"
                          :label="item.administrative_info.name.full_name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="12">
                    <el-form-item label="Tới:" prop="">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.to_id"
                        clearable
                        filterable
                        placeholder="Nhập nội dung và enter để tìm kiếm"
                        no-data-text="Không có dữ liệu"
                        :filter-method="remoteSearchTo"
                        :loading="loadingSearchTo"
                        @keyup.enter.native="fn_enterFindTo()"
                      >
                        <el-option
                          v-for="item in listEmployeeSearchTo"
                          :key="item.id"
                          :label="item.administrative_info.name.full_name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="12">
                    <el-form-item label="Tiêu đề:" prop="">
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value.name"
                        placeholder="Nhập nội dung"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="12">
                    <el-form-item label="Có các từ:" prop="">
                      <el-input
                        type="text"
                        v-model="
                          mData.tableRules.dataSearch.value.include_word_find
                        "
                        placeholder="Nhập nội dung"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="12">
                    <el-form-item label="Không có:" prop="">
                      <el-input
                        type="text"
                        v-model="
                          mData.tableRules.dataSearch.value.exclude_word_find
                        "
                        placeholder="Nhập nội dung"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-row class="d-flex align-items-center ml-3 mb-4 w-100">
                    <span class="bold label-custom">Kích thước</span>
                    <b-col class="pr-0">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.operator_str"
                        placeholder="Chọn"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFileSizeOperator"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </b-col>
                    <b-col class="pr-0">
                      <el-input-number
                        v-model.trim="
                          mData.tableRules.dataSearch.value.capacity
                        "
                        placeholder="Nhập nội dung"
                        clearable
                        :min="0"
                        controls-position="right"
                      ></el-input-number>
                    </b-col>
                    <b-col class="">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.unit"
                        clearable
                        placeholder="Chọn"
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFileSizeType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-center ml-3 mb-4 w-100">
                    <span class="bold label-custom">Trong Khoảng:</span>
                    <b-col class="pr-0">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.time_about"
                        clearable
                        filterable
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listDocDuration"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </b-col>
                    <span class="bold label-custom ml-3" style="width: 75px"
                      >Từ ngày:</span
                    >
                    <b-col>
                      <el-date-picker
                        placeholder="Nhập nội dung"
                        type="date"
                        v-model="mData.tableRules.dataSearch.value.date"
                        prefix-icon="isax-calendar-1"
                        :clearable="false"
                        format="dd/MM/yyyy"
                      ></el-date-picker>
                    </b-col>
                  </b-row>

                  <b-row class="d-flex align-items-center ml-3 mb-4 w-100">
                    <span class="bold label-custom">Tìm kiếm:</span>
                    <b-col class="pr-0">
                      <!-- <el-form-item label="Tìm kiếm:" prop=""> -->
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.type"
                        clearable
                        filterable
                        placeholder="Chọn"
                        @input="forceUpdateUI"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listDocContent"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- </el-form-item> -->
                    </b-col>
                    <span class="bold label-custom ml-3" style="width: 75px"
                      >Trạng thái:</span
                    >
                    <b-col>
                      <!-- <el-form-item label="Trạng thái:" prop=""> -->
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.status"
                        clearable
                        filterable
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listDocStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- </el-form-item> -->
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-center mb-4 ml-3 w-100">
                    <span class="bold label-custom"
                      >Trạng thái đọc:</span
                    >
                    <b-col class="pr-0">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.is_read"
                        clearable
                        filterable
                        placeholder="Chọn"
                        @input="forceUpdateUI"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listReadStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </b-col>
                    <span class="bold label-custom ml-3" style="width: 75px"
                      > </span
                    >
                    <b-col>
                      <el-checkbox
                        v-model="
                          mData.tableRules.dataSearch.value.has_attach_file
                        "
                        >Chứa tệp đính kèm</el-checkbox
                      >
                    </b-col>
                  </b-row>
                </b-row>
                <el-form-item
                  class="text-right mr-3 mb-0"
                  style="margin-top: -20px"
                >
                  <el-button
                    class="btn__doc btn__doc-back"
                    @click="clearFormSearch"
                    >Xóa tất cả</el-button
                  >
                  <el-button
                    class="btn__doc btn__doc-transfer"
                    native-type="submit"
                    @click="fn_filterDoc"
                    >Tìm kiếm</el-button
                  >
                </el-form-item>
              </el-card>
            </b-collapse>
          </div>
          <!-- End FILTERS -->
        </el-form>
      </div>
      <el-button
        v-if="viewMode == 'create'"
        class="btn__doc mr-1"
        @click="dialogInProcess = true"
        >Tải văn bản mẫu</el-button
      >
      <el-button
        v-if="viewMode == 'create'"
        class="btn__doc btn-default"
        @click="fn_goToCreate"
        >Tạo văn bản</el-button
      >
    </div>
    <!-- End Manipulation -->
    <!-- Start config Document Category -->
    <div class="text-right">
      <el-dropdown trigger="click" @command="fn_goToDocType">
        <i class="icon isax-setting-2" title="Cài đặt danh mục văn bản"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-caret-right" command="doc-type"
            >Lĩnh vực</el-dropdown-item
          >
          <!-- <el-dropdown-item icon="el-icon-caret-right" command="doc-textBook"
            >Sổ văn bản</el-dropdown-item
          > -->
          <el-dropdown-item
            icon="el-icon-caret-right"
            command="doc-organizationmodel"
            >Mô hình tổ chức</el-dropdown-item
          >
          <el-dropdown-item icon="el-icon-caret-right" command="doc-group"
            >Nhóm</el-dropdown-item
          >
          <el-dropdown-item icon="el-icon-caret-right" command="doc-business"
            >Ngành</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- End config Document Category -->
    <!-- Start Tab -->
    <el-tabs
      type="border-card"
      v-model="tabName"
      @tab-click="fn_handleClickTab"
    >
      <el-tab-pane name="TatCa" v-if="isSearching">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-Search mr-2"></i>
            <span>Tìm kiếm ({{ listDocumentFilterTotal }})</span>
          </div>
        </span>
        <div
          class="text-center center-block"
          v-if="listDocumentFilterTotal == 0"
        >
          <h5 class="empty__tab-text">Thẻ văn bản trống</h5>
          <p class="empty__tab-text">Các văn bản sẽ hiển thị ở đây.</p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'TatCa' && listDocumentFilterTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'FILTER'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
          :filtersDocument="mData.tableRules.filters"
          @deleteDocument="deleteDocument"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="VanBanDen">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon isax-sms-notification mr-2"></i>
            <span>Văn bản đến ({{ listDocumentInTotal }})</span>
          </div>
        </span>
        <div class="text-center center-block" v-if="listDocumentInTotal == 0">
          <h5 class="empty__tab-text">Thẻ văn bản đến trống</h5>
          <p class="empty__tab-text">
            Các văn bản được gửi đến bạn sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'VanBanDen' && listDocumentInTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_IN'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="KyDuyet">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-VB_ChoKyDuyet mr-2"></i>
            <span>Ký duyệt ({{ listDocumentSignConsentTotal }})</span>
          </div>
        </span>
        <div
          class="text-center center-block"
          v-if="listDocumentSignConsentTotal == 0"
        >
          <h5 class="empty__tab-text">Thẻ văn bản ký duyệt trống</h5>
          <p class="empty__tab-text">
            Các văn bản được gửi đến bạn sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'KyDuyet' && listDocumentSignConsentTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_SIGN_CONSENT'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="KyNhay">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-VB_ChoKyNhay mr-2"></i>
            <span>Ký nháy ({{ listDocumentSignTempTotal }})</span>
          </div>
        </span>
        <div
          class="text-center center-block"
          v-if="listDocumentSignTempTotal == 0"
        >
          <h5 class="empty__tab-text">Thẻ văn bản ký nháy trống</h5>
          <p class="empty__tab-text">
            Các văn bản được gửi đến bạn sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'KyNhay' && listDocumentSignTempTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_SIGN_TEMP'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="VanBanDi">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon isax-sms-tracking mr-2"></i>
            <span>Văn bản đi ({{ listDocumentOutTotal }})</span>
          </div>
        </span>
        <div class="text-center center-block" v-if="listDocumentOutTotal == 0">
          <h5 class="empty__tab-text">Thẻ văn bản đi trống</h5>
          <p class="empty__tab-text">
            Các văn bản được gửi đi từ bạn sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'VanBanDi' && listDocumentOutTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_OUT'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="TrinhKy">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-VB_TrinhKy mr-2"></i>
            <span>Trình ký ({{ listDocumentSignTotal }})</span>
          </div>
        </span>
        <div class="text-center center-block" v-if="listDocumentSignTotal == 0">
          <h5 class="empty__tab-text">Thẻ văn bản trình ký trống</h5>
          <p class="empty__tab-text">
            Các văn bản được trình ký sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'TrinhKy' && listDocumentSignTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_SIGN'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
          @deleteDocument="deleteDocument"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="ChoBanHanh" v-if="checkRoleDocument()">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-VB_TrinhKy mr-2"></i>
            <span>Chờ ban hành ({{ listDocumentIssueTotal }})</span>
          </div>
        </span>
        <div
          class="text-center center-block"
          v-if="listDocumentIssueTotal == 0"
        >
          <h5 class="empty__tab-text">Thẻ văn bản chờ ban hành trống</h5>
          <p class="empty__tab-text">
            Các văn bản chờ ban hành sẽ hiển thị ở đây.
          </p>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'ChoBanHanh' && listDocumentIssueTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_ISSUE'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
      <el-tab-pane name="CayThuMuc">
        <span slot="label">
          <div class="d-flex justify-content-center align-items-center">
            <i class="icon icon24-Tree mr-2"></i>
            <span>Cây thư mục</span>
          </div>
        </span>
        <div
          class="text-center center-block"
          v-if="listDocumentOrganizationTotal == 0"
        >
          <h5 class="empty__tab-text">Thẻ cây thư mục trống</h5>
        </div>
        <!-- Start Tab Body -->
        <ElectronicDocument
          v-if="tabName == 'CayThuMuc' && listDocumentOrganizationTotal > 0"
          :listDocumentType="mData.dataDefault.listDocumentType"
          :listEmployee="mData.dataDefault.listAllEmployee"
          :tab="'DOC_ORGANIZATIONMODEL'"
          :listDocumentBusiness="mData.dataDefault.listDocumentBusiness"
        />
        <!-- Start Tab Body -->
      </el-tab-pane>
    </el-tabs>
    <!-- End Tab -->

    <!-- Start dialog download -->
    <el-dialog
      :visible.sync="dialogInProcess"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          style="max-width: 50%"
          src="img/ProgressWorking.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center mb-2 font-xl">Tính năng đang được phát triển</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogInProcess = false"
          class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog download -->
    <div class="frame__disabled" v-if="mData.tableRules.showFormSearch"></div>
  </div>
</template>
<script>
import MethodService from "../../../service/MethodService";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import DocumentApi from "../../../moduleApi/DocumentApi";
import OrganizationModelApi from "../../../moduleApi/OrganizationModelApi";
import { dataDocMixins } from "../ElectronicDocument/DocumentMixins/dataDocMixins";
import { fnDocMixins } from "../ElectronicDocument/DocumentMixins/fnDocMixins";
import ElectronicDocument from "../ElectronicDocument/DocumentList.vue";
import { Filter } from "mushroomjs";
import EventBus from "@/service/EventBus";
export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    ElectronicDocument,
  },
  data() {
    return {
      moduleName: "DocumentsGeneral",
      tabName: "VanBanDen",
      dialogRecall: false,
      dialogInProcess: false,
      listDocumentIn: [],
      listDocumentOut: [],
      listDocumentSign: [],
      listDocumentSignConsent: [],
      listDocumentSignTemp: [],
      listDocumentIssue: [],

      listDocumentFilterTotal: 0,
      listDocumentInTotal: 0,
      listDocumentOutTotal: 0,
      listDocumentSignTotal: 0,
      listDocumentSignConsentTotal: 0,
      listDocumentSignTempTotal: 0,
      listDocumentIssueTotal: 0,
      listDocumentOrganizationTotal: 0,
      textFilter: "",
      loadingSearchFrom: false,
      listEmployeeSearchFrom: [],
      textFindFrom: "",
      loadingSearchTo: false,
      listEmployeeSearchTo: [],
      textFindTo: "",
      dataSearchProp: {},
      isSearching: false,

      prevFilter: "",
    };
  },
  methods: {
    checkRoleDocument() {
      if (!this.listRole || this.listRole.length == 0) return false;
      if (this.listRole.includes("VT")) return true;
    },

    remoteSearchFrom(queryString) {
      if (!queryString) return;
      this.textFindFrom = queryString.trim();
      this.listEmployeeSearchFrom = [];
    },

    async fn_enterFindFrom() {
      this.loadingSearchFrom = true;
      const res = await EmployeeApi.list(
        {
          filters: `$vn_text=${this.textFindFrom}`,
        },
        true
      );
      this.listEmployeeSearchFrom = res.result;
      this.loadingSearchFrom = false;
    },

    remoteSearchTo(queryString) {
      if (!queryString) return;
      this.textFindTo = queryString.trim();
      this.listEmployeeSearchTo = [];
    },

    async fn_enterFindTo() {
      this.loadingSearchTo = true;
      const res = await EmployeeApi.list(
        {
          filters: `$vn_text=${this.textFindTo}`,
        },
        true
      );
      this.listEmployeeSearchTo = res.result;
      this.loadingSearchTo = false;
    },

    fn_toggleFilter() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
    },

    clearFormSearch() {
      // this.$refs["formSearchDocument"].resetFields();
      // this.$refs.formSearchDocument.resetFields()
      this.mData.tableRules.dataSearch.value = {};
      this.listEmployeeSearchFrom = [];
      this.listEmployeeSearchTo = [];
    },

    fn_filterDoc() {
      let objFilter = undefined
      this.prevFilter = sessionStorage.getItem("filterDoc");
      if (this.prevFilter) {
        objFilter = { value: JSON.parse(this.prevFilter) };
      }
      if (
        MethodService.filterTable(JSON.stringify(objFilter)) !=
        MethodService.filterTable(
          JSON.stringify(this.mData.tableRules.dataSearch)
        )
      ) {
        this.mData.tableRules.filters = MethodService.filterTable(
          JSON.stringify(this.mData.tableRules.dataSearch)
        );

        sessionStorage.setItem(
          "filterDoc",
          JSON.stringify(this.mData.tableRules.dataSearch.value)
        );
      }

      this.dataSearchProp = this.mData.tableRules.dataSearch.value;
      if (typeof this.dataSearchProp.include_words == "string") {
        this.dataSearchProp.include_words = [];
      }
      if (typeof this.dataSearchProp.exclude_words == "string") {
        this.dataSearchProp.exclude_words = [];
      }
      this.fn_getTotalDocByType("FILTER");
      this.isSearching = true;
      this.tabName = "TatCa";
      this.$router
        .replace({
          query: {
            tab: this.tabName,
          },
        })
        .catch((err) => {});
      setTimeout(() => {
        this.mData.tableRules.showFormSearch = false;
      }, 300);
    },

    fn_handleClickTab(tab, event) {
      this.tabName = tab.name;
      this.$router
        .replace({
          query: {
            tab: this.tabName,
          },
        })
        .catch((err) => {});
      if (this.tabName == "TatCa") {
        this.fn_getTotalDocByType("FILTER");
      } else if (this.tabName == "VanBanDen") {
        this.fn_getTotalDocByType("DOC_IN");
      } else if (this.tabName == "KyDuyet") {
        this.fn_getTotalDocByType("DOC_SIGN_CONSENT");
      } else if (this.tabName == "KyNhay") {
        this.fn_getTotalDocByType("DOC_SIGN_TEMP");
      } else if (this.tabName == "VanBanDi") {
        this.fn_getTotalDocByType("DOC_OUT");
      } else if (this.tabName == "TrinhKy") {
        this.fn_getTotalDocByType("DOC_SIGN");
      } else if (this.tabName == "ChoBanHanh") {
        this.fn_getTotalDocByType("DOC_ISSUE", "SIGNED");
      } else if (this.tabName == "CayThuMuc") {
        this.fn_getTotalDocByType("DOC_ORGANIZATIONMODEL");
      }
      this.fn_eventBus(this.tabName, "list");
    },

    fn_goToDocType(docType) {
      if (docType == "doc-type") {
        this.$router.push({
          name: "Admin-CategoryManagement-DocumentType",
        });
      } else if (docType == "doc-textBook") {
        this.$router.push({
          name: "Admin-CategoryManagement-DocumentTextBook",
        });
      } else if (docType == "doc-organizationmodel") {
        this.$router.push({
          name: "Admin-CategoryManagement-DocumentOrganizationModel",
        });
      } else if (docType == "doc-group") {
        this.$router.push({
          name: "Admin-CategoryManagement-DocumentGroup",
        });
      } else if (docType == "doc-business") {
        this.$router.push({
          name: "Admin-CategoryManagement-DocumentBusiness",
        });
      }
    },

    async fn_getTotalDocByType(tabName) {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: "id",
        limit: 1,
      };
      if (tabName == "FILTER") {
        this.dataSearchProp.limit = 1;
        if (
          !this.dataSearchProp.include_word_find ||
          this.dataSearchProp.include_word_find == ""
        ) {
          this.dataSearchProp.include_words = [];
        } else if (
          this.dataSearchProp.include_word_find &&
          typeof this.dataSearchProp.include_word_find == "string"
        ) {
          this.dataSearchProp.include_words = MethodService.changeAlias(
            this.dataSearchProp.include_word_find
          )
            .toLowerCase()
            .split(" ");
        }

        if (
          !this.dataSearchProp.exclude_word_find ||
          this.dataSearchProp.exclude_word_find == ""
        ) {
          this.dataSearchProp.exclude_words = [];
        } else if (
          this.dataSearchProp.exclude_word_find &&
          typeof this.dataSearchProp.exclude_word_find == "string"
        ) {
          this.dataSearchProp.exclude_words = MethodService.changeAlias(
            this.dataSearchProp.exclude_word_find
          )
            .toLowerCase()
            .split(" ");
        }
        const res = await DocumentApi.SearchDocument(this.dataSearchProp, true);
        if (
          res &&
          res.result &&
          res.result.result &&
          res.result.result.length > 0
        ) {
          this.listDocumentFilterTotal = res.meta.total;
        } else {
          this.listDocumentFilterTotal = 0;
        }
      } else if (tabName == "DOC_ORGANIZATIONMODEL") {
        const organizationApiRes = await OrganizationModelApi.list(
          {
            limit: 1,
          },
          true
        );
        if (organizationApiRes.result) {
          this.listDocumentOrganizationTotal = organizationApiRes.meta.total;
        }
      } else {
        if (tabName == "DOC_IN") {
          const filter = Filter.or(
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.eq("publish.publisher_to_ids", "$$user_id"),
              Filter.eq("status", "PUBLISHED")
            ),
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.eq("signers.user_id", "$$user_id"),
              Filter.eq("status", "PUBLISHED")
            ),
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.elementMatch("signers", [
                Filter.eq("user_id", "$$user_id"),
                Filter.eq("status", "SIGNED"),
              ]),
              Filter.eq("status", "WAITING_FOR_SIGN")
            ),
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.eq("signers.user_id", "$$user_id"),
              Filter.eq("status", "SIGNED")
            ),
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.eq("signers.user_id", "$$user_id"),
              Filter.eq("status", "RECALLED")
            ),
            Filter.and(
              Filter.eq("company_id", '$$user_company_id'),
              Filter.eq("signers.user_id", "$$user_id"),
              Filter.eq("status", "TRANSFERED_OTHER_COMPANY")
            ),
            Filter.and(
              Filter.eq("company_id", "$$user_company_id"),
              Filter.eq("transfer.person_ids", "$$user_id"),
              Filter.in("status", ["PUBLISHED", "SIGNED", "TRANSFERED_OTHER_COMPANY"])
            ),
          ).build();
          dataFilter.filters = filter
          // dataFilter.filters = `:and:company_id=$$user_company_id,publish.publisher_to_ids=$$user_id,status=PUBLISHED|:and:company_id=$$user_company_id,signers.user_id=$$user_id,status=PUBLISHED|:and:company_id=$$user_company_id,signers.user_id=$$user_id,status=SIGNED|:and:company_id=$$user_company_id,signers.user_id=$$user_id,status=RECALLED`;
        } else if (tabName == "DOC_OUT") {
          // dataFilter.filters = `&company_id=$$user_company_id&author_id=$$user_id&status:in:SIGNED,PUBLISHED,RECALLED,TRANSFERED_OTHER_COMPANY`;
          const filter = Filter.and(
            Filter.eq("company_id", "$$user_company_id"),
            Filter.eq("author_id", "$$user_id"),
            Filter.in("status", ["SIGNED","PUBLISHED","RECALLED","TRANSFERED_OTHER_COMPANY"]),
          ).build();

          dataFilter.filters = filter;
        } else if (tabName == "DOC_SIGN") {
          // dataFilter.filters = `company_id=$$user_company_id&author_id=$$user_id&status:in:NEW,WAITING_FOR_SIGN,REJECT_FOR_SIGN,REJECTED`;
          const filter = Filter.and(
            Filter.eq("company_id", "$$user_company_id"),
            Filter.eq("author_id", "$$user_id"),
            Filter.in("status", ["NEW","WAITING_FOR_SIGN","REJECT_FOR_SIGN","REJECTED"]),
          ).build();

          dataFilter.filters = filter;
        } else if (tabName == "DOC_SIGN_CONSENT") {
          // dataFilter.filters = `company_id=$$user_company_id&status=WAITING_FOR_SIGN&signers:elemMatch:user_id=$$user_id,status=WAITING`;
          const filter = Filter.and(
            Filter.eq("company_id", "$$user_company_id"),
            Filter.eq("status", "WAITING_FOR_SIGN"),
            Filter.elementMatch("signers", [
              Filter.eq("user_id", "$$user_id"),
              Filter.eq("status", "WAITING"),
            ]),
          ).build();

          dataFilter.filters = filter;
        } else if (tabName == "DOC_SIGN_TEMP") {
          // dataFilter.filters = `company_id=$$user_company_id&status=WAITING_FOR_SIGN&signers:elemMatch:status=WAITING,request_temp_signers:elemMatch:user_id=$$user_id\\,status=NEW`;
          const filter = Filter.and(
            Filter.eq("company_id", "$$user_company_id"),
            Filter.eq("status", "WAITING_FOR_SIGN"),
            Filter.elementMatch("signers", [
              Filter.eq("status", "WAITING"),
              Filter.elementMatch("request_temp_signers", [
                Filter.eq("user_id", "$$user_id"),
                Filter.eq("status", "NEW"),
              ])
            ]),
          ).build();

          dataFilter.filters = filter;
        } else if (tabName == "DOC_ISSUE") {
          const filter = Filter.and(
            Filter.eq("company_id", "$$user_company_id"),
            Filter.eq("publish.is_auto", false),
            Filter.or(
              Filter.eq("status", "SIGNED"),
              Filter.eq("status", "RECALLED"),
              Filter.eq("status", "PUBLISHED")
            )
          ).build();
          dataFilter.filters = filter;
        }
        // Get Total
        if (tabName != "DOC_ORGANIZATIONMODEL") {
          const documentInApiRes = await DocumentApi.list(dataFilter);

          if (documentInApiRes.result && documentInApiRes.result.length > 0) {
            if (tabName == "DOC_IN") {
              this.listDocumentInTotal = documentInApiRes.meta.total;
            } else if (tabName == "DOC_OUT") {
              this.listDocumentOutTotal = documentInApiRes.meta.total;
            } else if (tabName == "DOC_SIGN") {
              this.listDocumentSignTotal = documentInApiRes.meta.total;
            } else if (tabName == "DOC_SIGN_CONSENT") {
              this.listDocumentSignConsentTotal = documentInApiRes.meta.total;
            } else if (tabName == "DOC_SIGN_TEMP") {
              this.listDocumentSignTempTotal = documentInApiRes.meta.total;
            } else if (tabName == "DOC_ISSUE") {
              this.listDocumentIssueTotal = documentInApiRes.meta.total;
            }
          } else {
            if (tabName == "DOC_IN") {
              this.listDocumentInTotal = 0;
            } else if (tabName == "DOC_OUT") {
              this.listDocumentOutTotal = 0;
            } else if (tabName == "DOC_SIGN") {
              this.listDocumentSignTotal = 0;
            } else if (tabName == "DOC_SIGN_CONSENT") {
              this.listDocumentSignConsentTotal = 0;
            } else if (tabName == "DOC_SIGN_TEMP") {
              this.listDocumentSignTempTotal = 0;
            } else if (tabName == "DOC_ISSUE") {
              this.listDocumentIssueTotal = 0;
            }
          }
        }
      }
    },

    deleteDocument() {
      this.fn_getTotalDocByType("FILTER");
      this.fn_getTotalDocByType("DOC_SIGN");
    },

    async fn_initData() {
      this.fn_getListAllEmployee();
      this.fn_getListDocumentBusiness();
      this.fn_getListDocumentRespectively("DOC_TYPE");
      this.fn_getListDocumentBook();
      this.fn_getTotalDocByType("FILTER");
      this.fn_getTotalDocByType("DOC_IN");
      this.fn_getTotalDocByType("DOC_OUT");
      this.fn_getTotalDocByType("DOC_SIGN");
      this.fn_getTotalDocByType("DOC_SIGN_CONSENT");
      this.fn_getTotalDocByType("DOC_SIGN_TEMP");
      this.fn_getTotalDocByType("DOC_ISSUE", "SIGNED");
      this.fn_getTotalDocByType("DOC_ORGANIZATIONMODEL");
    },

    fn_hashUrl() {
      if (this.$route.query.tab) {
        this.tabName = this.$route.query.tab;
        if (this.tabName == "TatCa") {
          let objFilter = {};
          this.prevFilter = sessionStorage.getItem("filterDoc");
          if (this.prevFilter) {
            objFilter = { value: JSON.parse(this.prevFilter) };
            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(objFilter)
            );
            this.dataSearchProp = JSON.parse(this.prevFilter);
            this.mData.tableRules.dataSearch.value = { ...this.dataSearchProp };
          } else if (this.$route.query.is_read != undefined) {
            objFilter = { value: {} };
            objFilter.value.is_read = this.$route.query.is_read.toString();

            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(objFilter)
            );
            this.dataSearchProp = objFilter.value;
            this.mData.tableRules.dataSearch.value = { ...this.dataSearchProp };
            sessionStorage.setItem(
              "filterDoc",
              JSON.stringify(this.mData.tableRules.dataSearch.value)
            );
          }
          this.isSearching = this.tabName == "TatCa" ? true : false;
        }
      } else {
        this.tabName = "VanBanDen";
      }
      this.fn_eventBus(this.tabName, "list");
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      this.$router
        .replace({
          name: "Admin-DocumentsGeneral",
          query: {
            // ...this.$route.query.filters,
            tab: this.tabName,
          },
        })
        .catch((err) => {});
    },

    fn_checkVisibleTabs() {
      if (this.listRole && this.listRole.includes("VT")) {
        this.mData.dataDefault.listDocContent = [
          {
            label: "Tất cả văn bản",
            value: "",
          },
          {
            label: "Văn bản đến",
            value: "VBI",
          },
          {
            label: "Văn bản đi",
            value: "VBO",
          },
          {
            label: "Trình ký",
            value: "TK",
          },
          {
            label: "Ký duyệt",
            value: "KD",
          },
          {
            label: "Ký nháy",
            value: "N",
          },
          {
            label: "Chờ ban hành",
            value: "CBH",
          },
        ];
      } else {
        this.mData.dataDefault.listDocStatus = [
          {
            label: "Mới",
            value: "DOC_NEW",
          },
          {
            label: "Chờ ký duyệt",
            value: "DOC_WAITING",
          },
          {
            label: "Chờ ký nháy",
            value: "DOC_DRAFF_WAITING",
          },
          {
            label: "Từ chối ký duyệt",
            value: "DOC_REJECTED",
          },
          {
            label: "Từ chối ký nháy",
            value: "DOC_DRAFF_REJECTED",
          },
          {
            label: "Hủy trình ký",
            value: "DOC_REJECT_FOR_SIGN",
          },
          {
            label: "Đã ký duyệt",
            value: "DOC_SIGNED",
          },
          {
            label: "Đã ký nháy",
            value: "DOC_DRAFF_SIGNED",
          },
          {
            label: "Đã ban hành",
            value: "DOC_PUBLISHED",
          },
        ];
      }
    },
  },


  async created() {
    this.fn_checkVisibleTabs();

    $(document).click(function (event) {
      let checkClickClass = false;
      event.target.classList.forEach((element) => {
        if (element == "icon24-Filter") checkClickClass = true;
        if (element == "el-input__inner") checkClickClass = true;
      });
      if (checkClickClass) return;
      if (
        $("#formSearchDocument") &&
        $("#formSearchDocument").length > 0 &&
        !$("#formSearchDocument").is(event.target) &&
        $("#formSearchDocument").has(event.target).length === 0
      ) {
        if ($("#formSearchDocument").hasClass("show")) {
          setTimeout(() => {
            $("#closeSearchBox").click();
          }, 100);
        }
      }
    });
    await this.fn_hashUrl();
    await this.fn_initData();
    EventBus.$on("changeTabBreadCrumb", (data) => {
      this.tabName = data;
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .isax-setting-2 {
  transition: 0.2s ease;
  &:hover {
    color: var(--orange);
  }
}
.label-custom {
  width: 120px;
  font-weight: 600;
  color: #606060;
}
.frame__disabled {
  position: absolute;
  pointer-events: auto;
  opacity: 0.5;
  width: 100%;
  top: 0;
  left: 0;
  height: calc(100vh - 65px);
  z-index: 3;
  background: rgb(176, 176, 176);
}
::v-deep .container-fluid {
  padding: 20px 15px 10px 25px;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ffeadc;
  color: var(--orange);
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}
::v-deep .el-tabs__content {
  .el-tab-pane {
    height: calc(100vh - 240px);
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.w-70 {
  width: 70%;
}
.w-30 {
  width: 30%;
}
::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;
  span {
    color: black;
  }
}
::v-deep .el-tabs__nav:not(.is-active)::after {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 2px;
  background: #d0d5d9;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;
    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }
  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    span {
      color: black;
      font-weight: bold;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .searchBox-container {
  position: relative;
  z-index: 4;
  .main-body-search {
    position: absolute;
    z-index: -1;
    width: 100%;
    left: 0px;
    top: 35px;
    .el-card {
      border: none !important;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
      max-height: calc(100vh - 125px);
      overflow: auto;
    }
    .el-form-item__label {
      font-weight: bold;
    }
  }
}
::v-deep .searchBox {
  .el-input__inner {
    z-index: 5;
    border: none !important;
    box-shadow: 0px 2px 4px rgb(0 0 0 / 16%) !important;
  }
}
::v-deep .el-input__inner {
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-textarea__inner {
  box-shadow: none !important;
  border-radius: 5px !important;
}

::v-deep .searchBox .el-input__suffix {
  padding: 8px 8px 0px;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: -2px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .icon {
  font-size: 21px;
  cursor: pointer;
}
::v-deep .icon24-Filter {
  font-size: 24px;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}
::v-deep .el-upload-dragger {
  height: 36px;
}
::v-deep .el-upload {
  position: relative;
}
::v-deep .el-upload__tip {
  position: absolute;
  top: 5px;
  left: 150px;
  font-style: italic;
  color: #606266;
  margin-top: 0;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
::v-deep .empty__tab-text {
  color: #b3b3b3;
}
</style>
